import cartApi from '@/api/cart';

const cart = {
  id: 'cart',
  namespaced: true,
  state: () => ({
    list: [], // 购物车列表
    selectedIds: [], // 已选列表
    isAllSelected: false, //是否全选
    cartSelectedTotalPrice: '0.00', // 选中项总金额
  }),
  getters: {
    totalPriceSelected: (state) => {
      let price = 0;
      if (!state.selectedIds.length) return price.toFixed(2);
      state.list.forEach((item) => {
        if (!state.selectedIds.includes(item.id)) return;
        const snap = item.snapshot_price != null && item.snapshot_price !== '' ? parseFloat(item.snapshot_price) : 0;
        const unit =
          !Number.isNaN(snap) && snap > 0
            ? snap
            : parseFloat(item.sku_price && item.sku_price.price) || 0;
        price += unit * item.goods_num;
      });
      return price.toFixed(2);
    },
  },
  actions: {
    // 获取购物车列表
    async getList({ commit }) {
      try {
        const { code, data } = await cartApi.list();
        if (code === 1) {
          commit('SET_LIST', data);
        } else {
          commit('SET_LIST', []);
        }
      } catch (e) {
        commit('SET_LIST', []);
      }
    },
    // 添加购物车
    async add({ commit, dispatch }, goodsInfo) {
      const { code } = await cartApi.append({
        goods_id: goodsInfo.goods_id,
        goods_num: goodsInfo.goods_num,
        goods_sku_price_id: goodsInfo.id,
        // 秒杀/活动商品加入购物车时透传 activity_id（后端支持则按活动价/库存计算）
        ...(goodsInfo.activity_id ? { activity_id: goodsInfo.activity_id } : {}),
      });
      if (code === 1) {
        dispatch('getList');
      }
    },

    // 更新购物车
    async update({ commit, dispatch }, goodsInfo) {
      const { code } = await cartApi.update({
        goods_id: goodsInfo.goods_id,
        goods_num: goodsInfo.goods_num,
        goods_sku_price_id: goodsInfo.goods_sku_price_id,
        ...(goodsInfo.activity_id ? { activity_id: goodsInfo.activity_id } : {}),
      });
      if (code === 1) {
        dispatch('getList');
      }
    },

    // 移除购物车
    async delete({ commit, dispatch }, ids) {
      if (typeof ids === 'array') {
        ids = ids.join(',');
      }
      const { code } = await cartApi.delete(ids);
      if (code === 1) {
        commit('SELECT_ALL', false);
        dispatch('getList');
      }
    },
  },
  mutations: {
    SET_LIST: (state, list) => {
      state.list = list;
    },
    // 全选
    SELECT_ALL: (state, flag) => {
      state.isAllSelected = flag;
      if (!flag) {
        state.selectedIds = [];
      } else {
        state.list.forEach((item) => {
          state.selectedIds.push(item.id);
        });
      }
    },
    // 选择购物车商品
    SELECT_SINGLE: (state, goodsId) => {
      if (!state.selectedIds.includes(goodsId)) {
        state.selectedIds.push(goodsId);
      } else {
        state.selectedIds.splice(state.selectedIds.indexOf(goodsId), 1);
      }
      state.isAllSelected = state.selectedIds.length === state.list.length;
    },
    // 清空购物车
    EMPTY_LIST: (state) => {
      state.list = [];
      state.selectedIds = [];
      state.isAllSelected = false;
      state.cartSelectedTotalPrice = '0.00';
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'cart-store',
      },
    ],
  },
};

export default cart;
